export default __webpack_public_path__ + "static/video-f3d8c06c1dc3a6b2ec8dd00888621d6c.mp4";